import React from "react";
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";
import WarrantyForm from "../WarrantyForm";

const TopSection = props => (
  <GridContainer className="nw-desktop-only">
    <GridRow className="wc-topsection-warranty-extension-imagecontainer">
      <GridColumn className="nwc-grid-col-sm-6 wc-topsection-imagecol">
        <WarrantyForm
          containerclassName="wc-topsection-formcontainer"
          formclassName="wc-topsection-form"
        />
      </GridColumn>
    </GridRow>
  </GridContainer>
);

export default TopSection;
